import React from 'react';
import styles from './index.module.css';
import Modal from 'react-responsive-modal';
import Loader from '../Loader';

const Index = ({
  children,
  open,
  onClose,
  title = '',
  loading,
  width = 600,
  singleTitle = '',
}) => {
  // Определяем текст заголовка
  let modalTitle = '';

  if (singleTitle) {
    modalTitle = singleTitle;
  } else if (open && typeof open === 'object' && open.id) {
    modalTitle = `Редактирование ${title}`;
  } else {
    modalTitle = `Создание ${title}`;
  }

  return (
    <Modal
      open={!!open}
      onClose={onClose}
      showCloseIcon={true}
      closeOnEsc={true}
      closeOnOverlayClick={true}
      animationDuration={400}
      center
      styles={{
        modal: {
          margin: '2.5rem auto',
          borderRadius: '0.75rem',
          width: '95%',
          maxWidth: `${width}px`,
          background: '#fff',
          boxShadow: '0 6px 20px rgba(0,0,0,0.15)',
          padding: '1.5rem 2rem',
        },
      }}
      classNames={{
        modal: styles.modal,
      }}
    >
      <div className={styles.title}>{modalTitle}</div>

      {loading ? (
        <div className={styles.loaderWrapper}>
          <Loader />
        </div>
      ) : (
        children
      )}
    </Modal>
  );
};

export default Index;
